/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEdit,
  faPlus,
  faRedo,
} from "@fortawesome/free-solid-svg-icons";
import BTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from 'react-bootstrap/Tooltip';
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { useTable } from "react-table";
import "./Users.css";
import { epochToDate } from "../../dateutils";
import { httpClient } from "../../request";
import { statusToIcon } from "../../status";

/**
 * @todo Support pagination
 *
 * @param {*} param0
 */
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <BTable striped bordered hover size="sm" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
  );
}

/**
 * @todo: Add ability to add/edit/delete users
 */
export default function Users() {
  const [isLoading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [users, setUsers] = useState([]);
  const [result, setResult] = useState(false);
  const [appIDIndex, setAppIDIndex] = useState(-1);
  const [selectedData, setSelectedData] = useState(true);

  const [createShow, setCreateShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const token = JSON.parse(localStorage.getItem("token"));

  const getUsers = (appID) => {
    httpClient
      .get(`/private/users?app=${appID}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        setUsers(responseData.users ? responseData.users : []);

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const handleChangeAppID = (e) => {
    const { id, value } = e.target;
    setAppIDIndex(value);

    getUsers(apps[value].PublicId);
  };

  const handleEditChange = (e) => {
    const { id, value } = e.target;
    setSelectedData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [createData, setCreateData] = useState({
    app: "",
    username: "",
    email: "",
    password: "",
    plan: "",
  });

  const handleCreateChange = (e) => {
    const { id, value } = e.target;
    setCreateData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCreateChangeDatetime = (id, m) => {
    setCreateData((prevState) => ({
      ...prevState,
      [id]: m.valueOf() / 1000,
    }));
  };

  const handleEditChangeCheckbox = (e) => {
    const { id } = e.target;
    setSelectedData((prevState) => ({
      ...prevState,
      [id]: e.target.checked,
    }));
  };

  const handleEditChangeDatetime = (id, m) => {
    setSelectedData((prevState) => ({
      ...prevState,
      [id]: m.valueOf() / 1000,
    }));
  };

  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => setEditShow(true);

  const handleCreateClose = () => setCreateShow(false);
  const handleCreateShow = () => setCreateShow(true);

  const getApps = () => {
    httpClient
      .get("/private/apps", {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        setApps(responseData.apps ? responseData.apps : []);

        setLoading(false);
      })
      .catch((error) => {
        // Catch edge cases, usually happens with network errors
        setResult({
          status: "danger",
          message: error.message,
        });
      });
  };

  const resetHwid = (appID, username) => {
    httpClient
    .put("/private/users", null, {
      headers: {
        Authorization: "Bearer " + token.token,
      },
      params: {
        app: appID,
        username: username,
        hwidReset: 'y'
      },
    })
    .then((response) => {
      setResult({
        status: "success",
        message: `Successfully reset HWID for user ${username}`,
      });

      getUsers(appID);
    })
    .catch((error) => {
      // The error has response, it likely has an error message from the API
      if (error.response) {
        const responseData = error.response.data;
        if ("errors" in responseData) {
          const firstError = responseData.errors[0];

          setResult({
            status: "danger",
            message: firstError.detail,
          });
        }
      } else {
        // Catch edge cases, usually happens with network errors
        setResult({
          status: "danger",
          message: error.message,
        });
      }
    });
  }

  const editSelectedUser = () => {
    let data = selectedData;

    if (data.password === "") {
      delete data["password"];
    }

    data.banned = selectedData.banned ? "y" : "n";
    if (data.email === "") {
      delete data["email"];
    }

    if (!selectedData.banned) {
      delete data["banReason"];
    }

    httpClient
      .put("/private/users", null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
        params: selectedData,
      })
      .then((response) => {
        setResult({
          status: "success",
          message: `Successfully updated user ${selectedData.username}`,
        });

        getUsers(data.app);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("errors" in responseData) {
            const firstError = responseData.errors[0];

            setResult({
              status: "danger",
              message: firstError.detail,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setEditShow(false);
  };

  const createUser = () => {
    const data = {
      app: apps[appIDIndex].PublicId,
      username: createData.username,
      password: createData.password,
      email: createData.email,
      plan: createData.plan,
      expiresAt: createData.expiresAt,
    };

    httpClient
      .post("/private/users", null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
        params: data,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully created new user",
          });

          getUsers(apps[appIDIndex].PublicId);
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setCreateShow(false);
  };

  const deleteUser = (username, appID) => {
    httpClient
      .delete(`/private/users?app=${appID}&username=${username}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: `Deleted user ${username}`,
          });

          // Reload the users since our data changed
          getUsers(appID);
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("errors" in responseData) {
            const firstError = responseData.errors[0];

            setResult({
              status: "danger",
              message: firstError.detail,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  // useEffect tells the component that it must do something after it has rendered
  useEffect(() => getApps(), []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      HWID reset
    </Tooltip>
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Users",
        columns: [
          {
            id: "id",
            Header: "ID",
            accessor: "Id",
          },
          {
            Header: "Username",
            accessor: "Username",
          },
          {
            Header: "HWID",
            accessor: (d) => {
              return d.HWID.substring(0, 4) + "...";
            },
          },
          {
            Header: "Plan",
            accessor: "Plan",
          },
          {
            Header: "Active Until",
            accessor: (d) => {
              return d.ExpiresAt
                ? epochToDate(d.ExpiresAt).toISOString()
                : "N/A";
            },
          },
          {
            Header: "Last Login",
            accessor: (d) => {
              return d.LastLogin
                ? epochToDate(d.LastLogin).toISOString()
                : "N/A";
            },
          },
          {
            Header: "Joined At",
            accessor: (d) => {
              return d.JoinedAt ? epochToDate(d.JoinedAt).toISOString() : "N/A";
            },
          },
          {
            id: "edit",
            Header: "",
            accessor: (row) => {
              return row;
            },
            Cell: ({ value }) => (
              <Button
                variant="warning"
                onClick={() => {
                  setSelectedData({
                    app: value.App,
                    username: value.Username,
                    email: "",
                    password: "",
                    plan: value.Plan,
                    expiresAt: value.ExpiresAt,
                    banned: value.Banned,
                    banReason: value.BanReason,
                  });
                  handleEditShow();
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            ),
          },
          {
            id: "hwidReset",
            Header: "",
            accessor: (d) => {
              return d;
            },
            Cell: ({ value }) => (
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <Button
                  variant="info"
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to reset this user's HWID?"
                      )
                    )
                    resetHwid(value.App, value.Username);
                  }}
                >
                  <FontAwesomeIcon icon={faRedo} />
                </Button>
              </OverlayTrigger>
            ),
          },
          {
            id: "del",
            Header: "",
            accessor: (d) => {
              return d;
            },
            Cell: ({ value }) => (
              <Button
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm("Are you sure you want to delete this user?")
                  )
                    deleteUser(value.Username, value.App);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="Users">
      <div className="mt-5">
        {result && (
          <Alert variant={result.status}>
            <span className="mr-1">
              <FontAwesomeIcon icon={statusToIcon[result.status]} />
            </span>
            <span>{result.message}</span>
          </Alert>
        )}

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div>
            <Form>
              <Form.Group controlId="appID">
                <Form.Label>App ID</Form.Label>
                <Form.Control
                  as="select"
                  onChange={handleChangeAppID}
                  defaultValue={`DEFAULT`}
                >
                  <option value="DEFAULT" disabled>
                    Select an app ID...
                  </option>
                  {apps.map((c, i) => {
                    // @todo: Try simplifying expression
                    return (
                      <option key={c.PublicId} value={i}>
                        {c.PublicId}
                      </option>
                    );
                  })}
                </Form.Control>
                <small className="form-text text-muted">
                  Select an app to show its files
                </small>
              </Form.Group>
            </Form>

            {appIDIndex >= 0 && (
              <div>
                <Table columns={columns} data={users} />
                {users.length === 0 && (
                  <p className="text-center">No data available</p>
                )}
              </div>
            )}

            <div className="float-right">
              <Button variant="success" onClick={handleCreateShow}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>

            <Modal show={editShow} onHide={handleEditClose}>
              <Modal.Header closeButton>
                <Modal.Title>Edit user</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="app">
                    <Form.Label>App ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedData.app}
                      onChange={handleEditChange}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedData.username}
                      onChange={handleEditChange}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="email">
                    <Form.Label>New email address</Form.Label>
                    <Form.Control
                      type="email"
                      value={selectedData.email}
                      onChange={handleEditChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="password">
                    <Form.Label>New password</Form.Label>
                    <Form.Control
                      type="password"
                      value={selectedData.password}
                      onChange={handleEditChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="plan">
                  <Form.Label>Plan</Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedData.plan}
                      onChange={handleEditChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="expiresAt">
                    <Form.Label>Active Until</Form.Label>
                    <Datetime
                      value={epochToDate(
                        selectedData.expiresAt
                      ).toLocaleString()}
                      onChange={(value) => {
                        handleEditChangeDatetime("expiresAt", value);
                      }}
                    />
                  </Form.Group>

                  <Form.Group controlId="banned">
                    <Form.Check
                      type="checkbox"
                      label="Banned"
                      defaultChecked={selectedData.banned}
                      onChange={handleEditChangeCheckbox}
                    />
                  </Form.Group>

                  <Form.Group controlId="banReason">
                    <Form.Label>Ban reason</Form.Label>
                    <Form.Control
                      type="text"
                      value={selectedData.banReason}
                      onChange={handleEditChange}
                      disabled={!selectedData.banned}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleEditClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={editSelectedUser}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={createShow} onHide={handleCreateClose}>
              <Modal.Header closeButton>
                <Modal.Title>Add user</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Form>
                  <Form.Group controlId="username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.username}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="email">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      value={createData.email}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={createData.password}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="plan">
                    <Form.Label>Plan</Form.Label>
                    <Form.Control
                      type="text"
                      value={createData.plan}
                      onChange={handleCreateChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="expiresAt">
                    <Form.Label>Expires At</Form.Label>
                    <Datetime
                      value={epochToDate(createData.expiresAt).toLocaleString()}
                      onChange={(value) => {
                        handleCreateChangeDatetime("expiresAt", value);
                      }}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleCreateClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={createUser}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/Users.js